import { StoreDispatch } from 'interfaces/component'
import { SortingState } from 'interfaces/table'
import { Transaction, TransactionUid } from 'interfaces/moneyflow'
import { Guards } from 'interfaces/guards'
import { transactionsGuard } from 'guards/moneyflowGuards'
import { getTransactionsActionCreator, toggleTransactionEditActionCreator } from 'actions/moneyflowActions'
import { connectShadedLoadable } from 'helpers/loadableHelpers'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import TransactionsModule, { TransactionsDispatchProps, TransactionsOwnProps, TransactionsStateProps } from 'components/features/pfm/TransactionsModule/TransactionsModule'
import { transactionEditingIdSelector, transactionsByTypeSelector, transactionsDataByTypeSelector } from 'selectors/moneyflowSelectors'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { createSelector } from 'reselect'
import { getPageSizeProps, getPaginatorProps } from 'helpers/tableHelpers'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { TransactionRecatFloatingPane } from 'interfaces/floatingPanes'
import { sortedLinkedMixedAccountsSelector } from 'selectors/linkageSelectors'
import { linkedMixedAccountsGuard } from 'guards/linkageGuards'

const createMapStateToProps = () => createSelector(
  transactionsDataByTypeSelector,
  transactionsByTypeSelector,
  transactionEditingIdSelector,
  isMobileSelector,
  sortedLinkedMixedAccountsSelector,
  (
    transactionsPaginatable,
    transactionsApp,
    editingId,
    isMobile,
    linkedAccounts,
  ) => {

    const {
      isLoading,
      sorting,
    } = transactionsApp

    if (!transactionsPaginatable) {
      throw createForgottenGuardError('TransactionsModuleContainer', 'transactionsGuard')
    }
    const { results } = transactionsPaginatable

    return {
      isMobile,
      isLoading,
      editingId,
      rowsCollection: results,
      sorting,
      paginator: getPaginatorProps(transactionsApp, transactionsPaginatable),
      pageSize: getPageSizeProps(transactionsApp),
      hasNoLinkedAccounts: !linkedAccounts || linkedAccounts.length === 0,
    }
  }
)

const mapDispatchToProps = (dispatch: StoreDispatch, { type }: TransactionsOwnProps): TransactionsDispatchProps => ({
  onPageClick: (page: number) => dispatch(getTransactionsActionCreator({ type, page })),
  onPageSizeClick: (pageSize: number) => dispatch(getTransactionsActionCreator({ type, pageSize, page: 1 })),
  changeSorting: (sorting: SortingState) => dispatch(getTransactionsActionCreator({ type, sorting })),
  onReadonlyCategoryClick: (transaction: Transaction) => {
    const pane: Partial<TransactionRecatFloatingPane> = {
      type: 'transaction-recat',
      transaction,
    }

    dispatch(modifyFloatingPaneActionCreator('transaction-recat', pane))
  },
  toggleTransactionEdit: (uid: TransactionUid, toggleValue: boolean) =>
    dispatch(toggleTransactionEditActionCreator(type, uid, toggleValue)),
})

const transactionsGuards: Guards<TransactionsOwnProps> = [
  linkedMixedAccountsGuard,
  transactionsGuard,
]

const TransactionsModuleContainer = connectShadedLoadable<
  TransactionsStateProps,
  TransactionsDispatchProps,
  TransactionsOwnProps
>(createMapStateToProps, mapDispatchToProps, transactionsGuards)(TransactionsModule)
export default TransactionsModuleContainer
